import { createElement, forwardRef } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';
import type { FlowProps } from './types';

import cx from 'classnames';
import cn from './Flow.css.json';
import './Flow.css';

export const Flow = forwardRef<HTMLDivElement, FlowProps>(function Flow(props, ref) {
  const { className, style, wrap, spacing, orientation, testId, ...restProps } = props;
  const dt = useDesignTokens();
  const size = spacing ?? 'm';
  const orientationProps = orientation ?? 'horizontal';

  const styleTokens = renderInlineCssVars({ 'gap-size': dt.spacing.core[size] }, 'flow');

  return (
    <div
      data-testid={testId}
      {...restProps}
      ref={ref}
      className={cx(wrap && cn.wrap, cn.flow[orientationProps], className)}
      style={{ ...styleTokens, ...style }}
    >
      {props.children}
    </div>
  );
});
